// English display labels only; the shared Arabic records retain their identity.
export const MATERIAL_NAMES = [
  ["بريشيا داينو", "Breccia Daino"], ["أرمانى براون", "Armani Brown"],
  ["فولاكس", "Volakas"], ["كريما مارفل", "Crema Marfil"], ["فانتستك", "Fantastic"],
  ["أروبيكا جراى", "Orobico Grey"], ["بيترا تركى", "Turkish Pietra"],
  ["كرارة تركى", "Turkish Carrara"], ["الكانتى", "Alicante"], ["بلطق براون", "Baltic Brown"],
  ["بلوجينز", "Blue Jeans"], ["هيرمس لايت", "Hermes Light"],
  ["امبرادور لايت", "Light Emperador"], ["امبرادور اسبانى", "Spanish Emperador"],
  ["ترفنتينو سلفر", "Silver Travertine"], ["اسود اسبانى", "Spanish Black"],
  ["بياترا ايرانى", "Iranian Pietra"], ["اليكسندر جراى", "Alexander Grey"],
  ["برديسيو", "Bardisio"], ["كشمير وايت", "Kashmir White"], ["بتشينو رويال", "Botticino Royal"],
  ["بلاك ماركينى", "Black Marquina"], ["بيانكو", "Bianco"], ["وودفين", "Wood Vein"],
  ["صوفيا", "Sophia"], ["كلاكتا جولد", "Calacatta Gold"], ["سلفر بورتورو", "Silver Portoro"],
  ["مرمره", "Marmara"], ["سبايدر", "Spider"],
  ["كرارا", "Carrara"], ["كراره", "Carrara"], ["جرانيت", "Granite"], ["رخام", "Marble"],
];

const arabic = /[\u0600-\u06ff\u0750-\u077f\u08a0-\u08ff\ufb50-\ufdff\ufe70-\ufeff]/;
const materialCollator = new Intl.Collator(["en", "ar"], { sensitivity: "base", numeric: true, ignorePunctuation: true });
export function sortMaterials(materials = [], label = material => material.name || material.material_name || "") {
  return [...materials].sort((a,b) => materialCollator.compare(String(label(a)).trim(), String(label(b)).trim()) || Number(a.id)-Number(b.id));
}
export const isEnglishLabel = value => !String(value || "").trim() || (/\p{Script=Latin}/u.test(value) && !arabic.test(value) && !/\p{L}/u.test(String(value).replace(/\p{Script=Latin}/gu, "")));
export const normalizeMaterialName = value => String(value || "").trim().toLowerCase()
  .replace(/[\u0640\u064b-\u065f\u0670]/g, "").replace(/[أإآ]/g, "ا").replace(/ى/g, "ي").replace(/ة/g, "ه").replace(/\s+/g, " ");
const translations = new Map(MATERIAL_NAMES.map(([name, english]) => [normalizeMaterialName(name), english]));
const details = new Map([
  ["ابيض", "White"], ["اسود", "Black"], ["رمادي", "Grey"], ["بني", "Brown"], ["بيج", "Beige"],
  ["اخضر", "Green"], ["احمر", "Red"], ["ذهبي", "Gold"], ["مصر", "Egypt"], ["ايطاليا", "Italy"],
  ["تركيا", "Turkey"], ["اسبانيا", "Spain"], ["اليونان", "Greece"], ["ايران", "Iran"], ["الهند", "India"],
].map(([name, english]) => [normalizeMaterialName(name), english]));

export function englishMaterialName(material) {
  if (!material) return "Unknown material";
  const english = String(material.name_en || "").trim();
  if (english && isEnglishLabel(english)) return english;
  const original = String(material.name || material.material_name || "").trim();
  return translations.get(normalizeMaterialName(original)) || (original && isEnglishLabel(original) ? original : `Material #${material.id} (English name needed)`);
}

export function englishMaterialDetail(material, field) {
  const english = String(material[`${field}_en`] || "").trim();
  if (english && isEnglishLabel(english)) return english;
  const original = String(material[field] || "").trim();
  return details.get(normalizeMaterialName(original)) || (isEnglishLabel(original) ? original : "Not specified");
}

export function englishMaterialAlias(value, materials = []) {
  const key = normalizeMaterialName(value);
  const material = materials.find(row => normalizeMaterialName(row.name || row.material_name) === key);
  return material ? englishMaterialName(material) : translations.get(key) || value;
}

export function englishComponentName(value) {
  const key = normalizeMaterialName(value);
  const components = { "سطح": "Top", "قاعده": "Base", "ارجل": "Legs" };
  return components[key] || (isEnglishLabel(value) ? value : "Component");
}

// Translate the recorded invoice snapshot rather than reconstructing its composition.
export function englishMaterialSnapshot(value, materials = []) {
  return String(value || "").split(/\s*\+\s*/).map(piece => {
    const colon = piece.indexOf(":");
    const name = colon < 0 ? piece.trim() : piece.slice(colon + 1).trim();
    const translated = englishMaterialAlias(name, materials);
    const label = isEnglishLabel(translated) ? translated : "Material (English name unavailable)";
    return colon < 0 ? label : `${englishComponentName(piece.slice(0, colon).trim())}: ${label}`;
  }).join(" + ");
}
